export default class MazeConst {

}

// MazeConst


MazeConst.ROOM_SIZE_SMALL = "SMALL";
MazeConst.ROOM_SIZE_MEDIUM = "MEDIUM";
MazeConst.ROOM_SIZE_LARGE = "LARGE";

MazeConst.ROOM_TYPE_HALLWAY = "typeHallway";
MazeConst.ROOM_TYPE_ONE_EXIT = "typeOneExit";
MazeConst.ROOM_TYPE_TWO_EXIT = "typeTwoExit";
MazeConst.ROOM_TYPES = [
	MazeConst.ROOM_TYPE_ONE_EXIT,
	MazeConst.ROOM_TYPE_TWO_EXIT,
	MazeConst.ROOM_TYPE_HALLWAY
]


MazeConst.FUSE_PLACE_ROOM = 100;
MazeConst.FUSE_CREATE_PATH = 1000;
MazeConst.FUSE_CHOOSE_CELL = 1000;
MazeConst.FUSE_CHOOSE_ROOM_EXIT = 1000;
MazeConst.FUSE_DIJKSTRA = 500;
MazeConst.FUSE_FIND_PATH = 100000;

MazeConst.INFINITE_DISTANCE = 999999;
MazeConst.BUILD_FAILURE_PERCENTAGE = 0.8;